import { Markdown, Title } from '../components/common'
import ReactMarkdown from 'react-markdown'
import Layout from '../components/layout'
import React from 'react'
import styled from 'styled-components'
import { useStaticQuery, graphql } from 'gatsby'

const Terms = () => {
  const termpager = useStaticQuery(graphql`
    query alltermsData {
      allMarkdownRemark {
        nodes {
          frontmatter {
            description
            heading
            templateKey
            title
          }
        }
      }
    }
  `)

  const {
    allMarkdownRemark: { nodes },
  } = termpager
  const Pagedata = nodes.filter(
    data => data.frontmatter.templateKey === 'terms-page'
  )?.[0]
  // console.log(Pagedata)
  return (
    <Layout>
      <Markdown>
        <Title id="-terms-and-conditions-">
          <strong>{Pagedata.frontmatter.heading}</strong>
        </Title>
        <Wrapper>
          <ReactMarkdown>
            {Pagedata.frontmatter.description}
          </ReactMarkdown>
        </Wrapper>
      </Markdown>
    </Layout>
  )
}

const Wrapper = styled.div`
  color: white;
  text-align: justify;
`
export default Terms
